import { useContext, useRef } from "react";

import { LanguageContext } from "../../../../../context/LanguageContext";
import { ParagraphText, UBButton, UBInput } from "../../../../../Libraries";
import { CloseIcon, UploadAttachment } from "../../../../../assets/icons/icon";

import { analytics, triggerLogEvent } from "../../../../../config/firebase";

import styles from "./styles.module.css";
import { sentenceCase } from "../../../../../constants";
import { ValidateUploadedFile } from "../../../../../utils";
import { useSnackbar } from "../../../../../context/SnackbarContext";

const SignatureSection = ({
  setSign = () => {},
  getSignImage = () => {},
  sign,
  type,
  isEditMode,
}) => {
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const fileInputRef = useRef();
  const UploadControl = ({ children, value, onChange, disabled, accept }) => {
    return (
      <label
        id="upload_control_id"
        htmlFor="contained-button-file"
        className={styles.uploadControlLabel}
      >
        <input
          ref={fileInputRef}
          value={value}
          accept={accept}
          disabled={disabled}
          className={styles.fileInputHidden}
          id="contained-button-file"
          multiple={false}
          type="file"
          onChange={disabled ? () => {} : onChange}
        />
        {children}
      </label>
    );
  };

  const handleUploadNewFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className={styles.sumSignSec}>
        
          <div
            className={styles.uploadSign}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleUploadNewFile();
              }
            }}
          >
            <UploadControl
              onChange={(e) => {
                const file = e?.target?.files?.[0];
                if (!file) return;
                const validation = ValidateUploadedFile({
                  file,
                  allowedTypes: ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"],
                  maxFileSize: 10,
                  sizeType: "MB",
                  I18n,
                });
                if (!validation.valid) {
                  showSnackbar({ message: validation.message, severity: "error" });
                  e.target.value = "";
                  return;
                }
                if (e?.target?.files?.[0])
                  triggerLogEvent(
                    analytics,
                    type === "in"
                      ? isEditMode
                        ? "inv_edit_upload_sign"
                        : "inv_upload_sign"
                      : isEditMode
                        ? "pb_edit_upload_sign"
                        : "pb_upload_sign",
                    {
                      method: "uploaded",
                      fileName: e.target.files[0].name,
                    },
                  );
                setSign({
                  type: "img",
                  value: e?.target?.files?.[0],
                });
              }}
              accept={"image/*"}
            >
              <span className={styles.uploadIcon}><UploadAttachment /></span>
              {sentenceCase(sign?.value?.name || "UPLOAD")}
            </UploadControl>
            {sign?.value ? (
            <UBButton
                id="sign_clear"
                className={styles.clearSigButton}
                iconComponent={<CloseIcon width={14} height={14} />}
                title=""
                onClick={() => {
                  setSign({
                    type: null,
                    value: null,
                  });
                }}
              />
            ) : (
              ""
            )}
          </div>
          <ParagraphText className={styles.spacerOr}>OR</ParagraphText>
          <div className={styles.signatureFieldAction}>
            <UBInput
              tabIndex={0}
              inputId="signature_input_field"
              baseClassname={styles.signatureField}
              placeholder={I18n.type_signature}
              inputClassname="inv_field overflow-hidden w-100 borderRadius6 signatureInput"
              value={sign?.type === "text" ? sign.value : ""}
              onChange={(e, value) => {
                if (
                  value?.length >= 1 &&
                  (sign?.value || "")?.length == 0 &&
                  !isEditMode
                )
                  triggerLogEvent(
                    analytics,
                    type === "in" ? "inv_sign_start" : "pb_sign_start",
                    { method: "typed" },
                  );
                setSign({ type: "text", value: value });
              }}
              maxLength={20}
            />
          </div>        
    </div>
  );
};
export default SignatureSection;
